import * as React from "react"
import { Route, Switch } from "react-router-dom"
import { ProductPages } from "./Pages/Pages"
import { ProductClicks } from "./Pages/Clicks"

export const Product: React.FC = () => {
    return <Switch>
        <Route path='/product/pages' component={ProductPages} />
        <Route path='/product/clicks' component={ProductClicks} />
    </Switch>
}


// WEBPACK FOOTER //
// ./src/pages/Product/index.tsx